export default function AdBlockReducer(state, action) {
    const { payload } = action;
    
    switch (action.type) {
        case "INIT_ADBLOCKS":
        return {
            ...state,
            isLoading: false,
            isRefetching: false,
            totalCount: 0,
            resultCount: 0,
            totalPages: 0,
            currentPage: 0,
            adBlockData: {},
            pageList: [],
            adBlockList: [],
        };
        case "GET_ADBLOCKS":
        return {
            ...state,
            adBlockList: payload.adBlocks,
            isLoading: false,
            isRefetching: false,
            totalCount: payload.total,
            resultCount: payload.adBlocks.length,
            totalPages: payload.pages,
            currentPage: 0,
        };
        case "GET_MORE_ADBLOCKS":
        return {
            ...state,
            adBlockList: [...state.adBlockList, ...payload.adBlocks],
            isRefetching: false,
            totalCount: payload.total,
            resultCount: payload.adBlocks.length,
            totalPages: payload.pages,
            currentPage: state.currentPage + 50,
        };
        case "SET_LOADING":
        return {
            ...state,
            isLoading: payload || true,
        };
        case "SET_SUBMITTING":
        return {
            ...state,
            isSubmitting: payload || false,
        };
        case "SET_FETCHING":
        return {
            ...state,
            isFetching: payload || false,
        };
        case "SET_SUGGESTION_LOADING":
        return {
            ...state,
            isSuggestionLoading: payload || false,
        };
        case "SET_ERROR":
        return {
            ...state,
            error: payload || null,
        };
        case "UPDATE_ADBLOCK_DATA":
        return {
            ...state,
            adBlockData: { ...state.adBlockData, ...payload },
        };
        case "RESET_ADBLOCK_STATE":
        return {
            ...state,
            adBlockData: {},
        };
        case "SET_IMAGE_DATA":
        return {
            ...state,
            ...payload,
        };
        case "SET_ADBLOCK_COORDS":
        return {
            ...state,
            adblockCoords: payload,
        };
        case "SET_SECTION_COORDS":
        return {
            ...state,
            sectionCoords: payload,
        };
        case "SET_PAGE_DIMENSIONS":
        return {
            ...state,
            pageWidth: payload.width,
            pageHeight: payload.height,
        };
        case "SET_ADBLOCK_FILENAME":
        return {
            ...state,
            adblockFilename: payload,
        };
        case "SET_PAGE_IMAGE":
        return {
            ...state,
            pageImg: payload,
        };
        case "SET_PAGE_LIST":
        return {
            ...state,
            pageList: payload,
        };
        case "SET_ADBLOCK_LIST":
        return {
            ...state,
            adBlockList: payload,
        };
        case "SET_CURRENT_ADBLOCK_DATA":
        return {
            ...state,
            currentAdBlockData: payload,
        };
        case "SET_CIRCULAR_METADATA":
        return {
            ...state,
            ...payload,
        };
        case "SET_ADBLOCK_METADATA":
        return {
            ...state,
            ...payload,
        };
        case "SET_ADBLOCK_STATUS":
        return {
            ...state,
            stage: payload,
        };
        case "SET_ADBLOCK_EVENTS":
        return {
            ...state,
            events: payload,
        };
        case "SET_ADBLOCK_INFO":
        return {
            ...state,
            adblock_info: payload,
        };
        case "SET_ADBLOCK_START_TIME":
        return {
            ...state,
            startTime: payload,
        };
        case "SET_ADBLOCK_IMPORT_STATUS":
        return {
            ...state,
            isImported: payload,
        };
        case "SET_ADBLOCK_NEW_ITEM_FLAG":
        return {
            ...state,
            new_item_f: payload,
        };
        case "SET_ADBLOCK_SELECT_VARIETIES_FLAG":
        return {
            ...state,
            select_varities_f: payload,
        };
        case "SET_ADBLOCK_BULK_QTY_FLAG":
        return {
            ...state,
            bulk_qty_f: payload,
        };
        case "SET_ADBLOCK_ANOMALY_FLAG":
        return {
            ...state,
            anomaly_f: payload,
        };
        case "SET_ADBLOCK_SPLIT_FLAG":
        return {
            ...state,
            split_f: payload,
        };
        case "SET_PRODUCT_DATA":
        return {
            ...state,
            productData: payload,
        };
        case "SET_OFFER_DATA":
        return {
            ...state,
            offerData: payload,
        };
        case "SET_CIRCULAR_NAME":
        return {
            ...state,
            circularName: payload,
        };
        case "SET_CIRCULAR_TYPE":
        return {
            ...state,
            circularType: payload,
        };
        case "SET_RETAILER_ID":
        return {
            ...state,
            retailerID: payload,
        };
        case "SET_PAGE_TYPE":
        return {
            ...state,
            pageType: payload,
        };
        case "RESET_PAGE_STATE":
        return {
            ...state,
            pageList: [],
            adBlockList: [],
            pageImg: "",
            pageWidth: 0,
            pageHeight: 0,
        };
        case "SET_ADBLOCK_DATA_PRODUCTS":
        return {
            ...state,
            adBlockData: {
                ...state.adBlockData,
                adBlockProducts: payload,
            },
        };
        case "SET_ADBLOCK_DATA_OFFERS":
        return {
            ...state,
            adBlockData: {
                ...state.adBlockData,
                adBlockOffers: payload,
            },
        };
        case "SET_ACTIVE_TAB":
        return {
            ...state,
            activeTab: payload,
        };
        case "SET_APPROVAL_STATUS":
        return {
            ...state,
            approvalStatus: payload,
        };
        case "RESET_PAGE":
        return {
            ...state,
            pageList: [],
            adBlockList: [],
            pageImg: "",
            pageWidth: 0,
            pageHeight: 0,
            currentAdBlockData: [],
        };
        default:
        return state;
    }
    }
    const initialState = {
        // Loading states
        isLoading: false,
        isSubmitting: false,
        isFetching: false,
        isRefetching: false,
        isSuggestionLoading: false,

        // Pagination
        totalCount: 0,
        resultCount: 0,
        totalPages: 0,
        currentPage: 0,

        // Image data
        pageWidth: 0,
        pageHeight: 0,
        pageImg: "",
        adblockFilename: "",
        imageWidth: 0,
        imageHeight: 0,
        adblockCoords: {
            coords_x1: 0,
            coords_y1: 0,
            coords_x2: 0,
            coords_y2: 0,
        },
        sectionCoords: {
            coords_x1: 0,
            coords_y1: 0,
            coords_x2: 0,
            coords_y2: 0,
        },

        // List Data
        pageList: [],
        adBlockList: [],

        // Current Info
        circularName: "",
        circularType: "",
        retailerID: "",
        pageType: "",

        // AdBlock Meta Data
        events: [],
        new_item_f: false,
        select_varities_f: false,
        bulk_qty_f: false,
        anomaly_f: false,
        split_f: false,
        startTime: "",
        isImported: false,
        adblock_info: {},

        // Block Status
        stage: "",

        //Entry Data
        productData: [],
        offerData: [],

        currentAdBlockData: [],
        error: null,

        // AdBlock Data (for backward compatibility)
        adBlockData: {
            id: "",
            name: "",
            retailerID: "",
            circularID: "",
            pageID: "",
            pageType: "",
            coords_x1: 0,
            coords_y1: 0,
            coords_x2: 0,
            coords_y2: 0,
            sectionCoords: {
                coords_x1: 0,
                coords_y1: 0,
                coords_x2: 0,
                coords_y2: 0,
            },
            adBlockType: "",
            adBlockStatus: "",
            adBlockData: {},
            adBlockProducts: [],
            adBlockOffers: [],
            adBlockImages: [],
            adBlockEvents: [],
            adBlockAnomalies: [],
            adBlockSplit: [],
            adBlockBulkQty: [],
            adBlockSelectVarieties: [],
            adBlockNewItem: false,
            startTime: "",
            isImported: false,
            adblock_info: {},
        },
    };

export { initialState };
